import {Badge, Button, Rate, Tooltip} from "antd";
import {DownCircleOutlined, RetweetOutlined, CloseCircleOutlined, DeleteOutlined} from '@ant-design/icons';

import FileShortList from "../../shared/components/FileShortList";

export const statusIcon = {
    pending: <RetweetOutlined className="wait-icon"/>,
    verified: <DownCircleOutlined className="accepted-icon"/>,
    rejected: <CloseCircleOutlined className="rejected-icon"/>,
};

export const statusText = {
    pending: "Pending",
    verified: "Validated",
    rejected: "Rejected",
};

const userTypes = {
    "Client (Company)": "success",
    "Client (Individual)": "success",
    Delegate: "processing",
};

const userTypesText = {
    "Client (Company)": "Client",
    "Client (Individual)": "Client",
    Delegate: "Delegate",
};

export const renderDetails = (showDetails, updateStatus, onDeleteClick, updatingId) => {
    return (_, record) => {
        const loading = updatingId === record.id;

        return (<div className="registration-actions">
            <Button size="small" onClick={() => showDetails(record.id)}>Details</Button>
            <Button size="small" type="primary" loading={loading}
                    disabled={record.status === "verified"}
                    onClick={() => updateStatus(record.id, "verified")}>Validate</Button>
            <Button size="small" danger loading={loading}
                    disabled={record.status === "rejected"}
                    onClick={() => updateStatus(record.id, "rejected")}>Reject</Button>
            <Tooltip title="Delete user">
                <Button size="small" type="text" danger icon={<DeleteOutlined/>}
                        aria-label="Delete user" onClick={() => onDeleteClick(record.id, "delete")}/>
            </Tooltip>
        </div>)
    }
}

export const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: "name",
        width: 200,
        fixed: "left",
        sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
        title: 'User Type',
        dataIndex: 'userType',
        key: 'userType',
        width: 150,
        fixed: "left",
        filters: [
            {
                text: 'Client (Individual)',
                value: 'Client (Individual)',
            },
            {
                text: 'Client (Company)',
                value: 'Client (Company)',
            },
            {
                text: 'Delegate',
                value: 'Delegate',
            },
        ],
        onFilter: (value, record) => record.userType === value,
        render: (userType) => <span><Badge className="user-badge" status={userTypes[userType]}/>{userTypesText[userType]}</span>,
    },
    {
        title: 'Avg Rating',
        dataIndex: 'avgRating',
        key: "avgRating",
        filters: [
            {
                text: '5 stars',
                value: 5,
            },
            {
                text: '4 stars',
                value: 4,
            },
            {
                text: '3 stars',
                value: 3,
            },
            {
                text: '2 stars',
                value: 2,
            },
            {
                text: '1 star',
                value: 1,
            },
        ],
        onFilter: (value, record) => record.avgRating === value,
        sorter: (a, b) => a.avgRating - b.avgRating,
        render: (avgRating) => {
          if(avgRating) {
              return <Rate disabled allowHalf defaultValue={avgRating} />
          }
        },
        width: 200,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: "email",
        sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
        title: 'Phone number',
        dataIndex: 'phone',
        key: "phone",
        sorter: (a, b) => a.phone.localeCompare(b.phone),
        width: 150,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: "date",
        sorter: (a, b) =>{
            // const format = "YYYY-MM-DD";
            // const result = moment(a.date, format).isBefore(moment(b.date, format));
            const [aYear, aMonth, aDay] = a.date.split("-");
            const [bYear, bMonth, bDay] = b.date.split("-");
            const result = new Date(aYear, aMonth - 1, aDay) - new Date(bYear, bMonth - 1, bDay);
            return result;
        },
        width: 150,
    },
    {
        title: 'Files',
        dataIndex: 'files',
        render: (files) => <FileShortList files={files} />,
        width: 100,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: "status",
        filters: [
            {
                text: 'Pending',
                value: 'pending',
            },
            {
                text: 'Verified',
                value: 'verified',
            },
            {
                text: 'Rejected',
                value: 'rejected',
            },
        ],
        onFilter: (value, record) => record.status === value,
        render: (status) => <div className="table-status">{statusIcon[status]} <span>{statusText[status]}</span></div>,
        width: 130,
    },
    {
        title: 'Action',
        dataIndex: 'details',
        key: "details",
        width: 300,
        fixed: "right",
    },
];
